export default __webpack_public_path__ + "static/media/zipper.3cc146c7.jpg";